function isFunction(value) {
    return typeof value === 'function';
}

export { isFunction };
//# sourceMappingURL=isFunction.js.map
